import { render, staticRenderFns } from "./FileClaim.vue?vue&type=template&id=907316bc&"
import script from "./FileClaim.vue?vue&type=script&lang=js&"
export * from "./FileClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports